export const PARAMS = {
  page: '1',
  per_page: '25',
  query: null,
  statuses: null,
  dealer: null,
  date_from: null,
  date_to: null,
  system: null,
};

export default {
  supplier: [],
  supplierArchived: [],
  dealers: [],
  dealersArchived: [],
  pagination: null,
  params: {
    ...PARAMS,
  },
  statuses: [],
  reclamation: null,
  search: null,
};
